/**
 * Path matchers for TactiCore authoring / app-chrome surfaces.
 * Apex: /tacticore/...
 * Host: root paths (no /tacticore prefix).
 *
 * Marketing product root `/tacticore` (or `/` on host) is intentionally excluded.
 */

function normalizePathname(pathname: string): string {
  return (pathname.replace(/\/$/, '') || '/').split('?')[0] ?? '/';
}

/** Lesson-plan new / edit only (form surfaces). */
export function isTacticoreLessonPlanAuthoringPath(pathname: string): boolean {
  const path = normalizePathname(pathname);
  if (path === '/tacticore/lesson-plans/new' || path === '/lesson-plans/new') {
    return true;
  }
  if (/^\/tacticore\/lesson-plans\/[^/]+\/edit$/.test(path)) return true;
  if (/^\/lesson-plans\/[^/]+\/edit$/.test(path)) return true;
  return false;
}

/**
 * Authenticated TactiCore app surfaces that use immersive chrome + mini footer
 * when the unit-structure UX flag is on: form new/edit plus managers list,
 * library, and exams (not the public marketing root).
 */
export function isTacticoreAppChromePath(pathname: string): boolean {
  if (isTacticoreLessonPlanAuthoringPath(pathname)) return true;
  const path = normalizePathname(pathname);
  if (path === '/tacticore/lesson-plans' || path === '/lesson-plans') return true;
  if (path === '/tacticore/library' || path === '/library') return true;
  if (path === '/tacticore/exams' || path === '/exams') return true;
  return false;
}

/** Authoring chrome is active only when the Vite UX flag is on and the path matches. */
export function shouldUseTacticoreAuthoringChrome(
  pathname: string,
  unitStructureUxEnabled: boolean,
): boolean {
  return unitStructureUxEnabled && isTacticoreAppChromePath(pathname);
}
